import { Controller } from 'stimulus';

class PopupModalController extends Controller {
  static targets = [ 'container' ];
  static values = {url: String};

  connect() {
    this.toggleClass = 't-hidden';
  }

  open(e) {
    e.preventDefault();

    if (!this.hasContainerTarget) {
      fetch(this.urlValue)
        .then((response) => {
          if (!response.ok) {
              throw Error(response.statusText);
          }
          return response;
        })
        .then((r) => r.text())
        .then((html) => {
          const fragment = document
            .createRange()
            .createContextualFragment(html);
          this.element.appendChild(fragment);
          this.containerTarget.classList.remove(this.toggleClass);
        })
        .catch();
    } else {
      this.containerTarget.classList.remove(this.toggleClass);
    }

  }

  close(e) {
    e.preventDefault();

    this.containerTarget.classList.add(this.toggleClass);
  }
}

export default PopupModalController;